import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GochiKidMenuTableHead from '../../components/molecules/GochiKidMenuTableHead';
import GochiKidMenuTableBody from '../../components/molecules/GochiKidMenuTableBody';
import ExPagination from '../../components/molecules/ExPagination';
import GochiMenuDetail from './GochiMenuDetail';
import RemoveGochiKidDialog from '../../components/molecules/RemoveGochiKidDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGochiMenus,
  getGochiMenuDetail,
  removeGochiKidMenu,
  addGochiKidMenu,
  getSettingMenuFree,
  GET_SETTING_MENU_FREE_SUCCESS
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ContentDialog from '../../components/molecules/ContentDialog';
import AddGochiKidDialog from '../../components/molecules/AddGochiKidDialog';
import SettingMenuFreeModal from '../../components/molecules/SettingMenuFreeModal';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          removeGochiKidMenu,
          addGochiKidMenu,
          getSettingMenuFree
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState(
    'openSettingMenuFreeModal',
    'updateOpenSettingMenuFreeModal',
    false
  ),
  withState('openRemove', 'updateOpenRemove', false),
  withState('loading', 'updateLoading', false),
  withState('isSuccess', 'updateIsSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHide', 'setShowHide', 1),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('message', 'setMessage', ''),
  withState('detail', 'setDetail', {}),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('menuSetting', 'setMenuSetting', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    page,
    selectedPage,
    handleChangePage,
    menus,
    totalCount,
    offset,
    openDetailModal,
    updateOpenDetailModal,
    openRemove,
    updateOpenRemove,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    updateOpenEdit,
    loading,
    updateLoading,
    isSuccess,
    updateIsSuccess,
    resultMessage,
    setResultMessage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    detail,
    setDetail,
    menuGenre,
    menuSituation,
    menuUserTarget,
    openAdd,
    updateOpenAdd,
    openProgress,
    isAddGochiKidMenu,
    updateOpenProgress,
    openSettingMenuFreeModal,
    updateOpenSettingMenuFreeModal,
    menuSetting,
    setMenuSetting
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const getGochiMenu = async id => {
      await actions.getGochiMenuDetail(id).then(detailData => {
        checkSession(detailData);
        const dataDetail = _.cloneDeep(detailData.payload);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          dataDetail.reducedTaxCheck = true;
          dataDetail.reducedTaxTypeStr = '対象';
        } else {
          dataDetail.reducedTaxCheck = false;
          dataDetail.reducedTaxTypeStr = '対象外';
        }
        dataDetail.tagStr = detailData.payload.tags
          .map(tag => {
            return `${tag.tagName}`;
          })
          .join(' ');

        if (detailData.payload.menuGenreId) {
          dataDetail.menuGenreName = menuGenre.find(
            genre =>
              genre.menuGenreId.toString() ===
              detailData.payload.menuGenreId.toString()
          ).menuGenreName;
          dataDetail.menuGenreId = detailData.payload.menuGenreId;
        } else {
          dataDetail.menuGenreName = '';
          dataDetail.menuGenreI = null;
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          dataDetail.menuSituationIds = detailData.payload.menuSituationIds;
          dataDetail.menuSituationNames = situationNames.join(', ');
        } else {
          dataDetail.menuSituationIds = [];
          dataDetail.menuSituationNames = '';
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuUserTargetIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          dataDetail.menuUserTargetIds = detailData.payload.menuUserTargetIds;
          dataDetail.menuUserTargetNames = userTargetNames.join(', ');
        } else {
          dataDetail.menuUserTargetIds = [];
          dataDetail.menuUserTargetNames = '';
        }
        if (detailData.payload.subscription) {
          dataDetail.subscription = detailData.payload.subscription;
          dataDetail.subscriptionInterval =
            detailData.payload.subscriptionInterval;
          dataDetail.subscriptionIntervalCount =
            detailData.payload.subscriptionIntervalCount;
        }
        setDetail(dataDetail);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiMenu(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const removeOpenAction = id => {
      updateOpenRemove(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenRemove(false);
    const removeAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const removeMenu = await actions
        .removeGochiKidMenu(targetRowId, { gochiKidFlag: 0 })
        .then(data => checkSession(data));
      if (removeMenu.type === 'REMOVE_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const addOpenAction = id => {
      updateOpenAdd(true);
      setTargetRowId(id);
    };
    const cancelAddAction = () => updateOpenAdd(false);
    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const params = {
        gochiKidFlag: 1
      };
      const addGochiKid = await actions
        .addGochiKidMenu(targetRowId, params)
        .then(data => checkSession(data));
      if (addGochiKid.type === 'ADD_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isSuccess) {
        updateOpenRemove(false);
        updateOpenAdd(false);
        updateOpenDetailModal(false);
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    const openSettingMenuFreeModalAction = async id => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getSettingMenuFree(id)
        .then(data => checkSession(data));
      if (response.type === GET_SETTING_MENU_FREE_SUCCESS) {
        setMenuSetting(response.payload);
        updateOpenSettingMenuFreeModal(true);
      }
      updateLoading(false);
      updateOpenProgress(false);
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiKidMenuTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GochiKidMenuTableBody
              menus={menus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              detailOpenAction={detailOpenAction}
              removeOpenAction={removeOpenAction}
              order={order}
              orderBy={orderBy}
              addOpenAction={addOpenAction}
              isAddGochiKidMenu={isAddGochiKidMenu}
              openSettingMenuFreeModalAction={openSettingMenuFreeModalAction}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={menus}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GochiMenuDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
          />
        </Modal>
        <RemoveGochiKidDialog
          openRemove={openRemove}
          updateOpenRemove={updateOpenRemove}
          cancelAction={cancelAction}
          removeAction={removeAction}
          targetRowId={targetRowId}
          target=""
        />
        <AddGochiKidDialog
          openAdd={openAdd}
          updateOpenAdd={updateOpenAdd}
          cancelAction={cancelAddAction}
          addAction={addAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />

        <Modal
          className={classes.modal}
          open={openSettingMenuFreeModal}
          onClose={() => {
            updateOpenSettingMenuFreeModal(false);
          }}
        >
          <SettingMenuFreeModal
            openSettingMenuFreeModal={openSettingMenuFreeModal}
            updateOpenSettingMenuFreeModal={updateOpenSettingMenuFreeModal}
            menuSetting={menuSetting}
            progress={progress}
            handleChangePage={handleChangePage}
            selectedPage={selectedPage}
            rowsPerPage={rowsPerPage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
